import * as React from 'react';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './assets/infoItem.module.scss';

interface Props {
    value: ReactNode | string;
    title: string;
}

const InfoItem: FC<Props> = ({ value, title }: Props) => {
    return (
        <div className={classNames(styles.infoItem)}>
            {title ? <span className={classNames(styles.titleItem)}>{title}</span> : null}
            <span className={classNames(styles.titleItemText)}>{value}</span>
        </div>
    );
};

export default InfoItem;
